module.exports = __webpack_public_path__ + "img/performance-icon.7333b899.png";